import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../api";

export default function Uitschrijven() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/unsubscribe", { email });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <section className="ok-section">
      <div className="ok-container max-w-lg text-center">
        <div className="ok-eyebrow mb-3">Nieuwsbrief</div>
        <h1 className="font-display text-4xl font-bold tracking-tight">Uitschrijven</h1>
        {done ? (
          <div className="mt-10 p-6 bg-[#e6f0f1] border border-[#01696f] text-[#01696f]" data-testid="unsubscribe-done">
            Bedankt. Je bent uitgeschreven van onze nieuwsbrief.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 space-y-5 text-left">
            <div>
              <label className="block text-xs uppercase tracking-wider font-semibold text-[#4a5d5e] mb-2">E-mailadres</label>
              <input data-testid="unsubscribe-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2.5 border border-[#e2e8f0] text-sm bg-white" />
            </div>
            <button data-testid="unsubscribe-submit" disabled={busy}
              className="w-full bg-[#01696f] text-white py-3 rounded-sm hover:bg-[#015257] disabled:opacity-60 font-medium">
              {busy ? "Bezig…" : "Uitschrijven"}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
